import { inputValidationCheck } from '../../../../validators/inputValidators/inputValidators'

export const getTableColumnValidators = (tableSchema: any) => {
    const tableColumns = Object.keys(tableSchema)
    const columnsValidators = tableColumns.reduce((acc: any, column) => {
        const columnSchema = tableSchema[column]
        const columnValidator = inputValidationCheck(
            columnSchema?.type,
            columnSchema
        )
        acc[column] = columnValidator
        return acc
    }, {})

    return columnsValidators
}
